<template>
  <Layout>
    <template #center-content>
      <div class="pa-6 px-md-6 py-md-0">
        <v-img
          src="../assets/new-logo.svg"
          width="168"
          height="48"
          class="mb-4 d-md-none"
          contain
        />
        <div class="d-flex align-baseline pt-md-6">
          <BaseHeader class="mb-4 neutral--text">
            <span>{{ pageTitle }}</span>
          </BaseHeader>
          <v-spacer />
          <div class="d-md-none">
            <font-awesome-icon
              icon="fa-light fa-sliders-up"
              class="brand-secondary--text"
              size="lg"
              @click="openFilterDialog = true"
            />
            <BaseDialog
              :value="openFilterDialog"
              @close="openFilterDialog = false"
              overlay-color="neutral tone-900"
              overlay-opacity="0.96"
              content-class="bottom-dialog"
            >
              <template #content>
                <TheSubscriptionFilter
                  title="Filtres"
                  :filters-items="subscriptionTypes"
                  filters-submit-button-text="Valider"
                  header-action-button-text="Supprimer tous les filtres"
                  @filter="openFilterDialog = false; recycleScrollerKey += 1"
                />
              </template>
            </BaseDialog>
          </div>
        </div>
        <BaseCardWithIcon
          :title="item.title"
          @click.native="goToSubscription(item)"
          icon="fa-light fa-dumbbell"
          class="mb-4 course-card"
          :chip-text="chipText(item.confirmed, item.rejected_at)"
          :chip-additional-classes="chipClass(item.confirmed, item.rejected_at)"
          v-for="item in filteredSubscriptions"
          :key="item.id"
        >
          <BaseIconWithText
            icon="fa-light fa-location-dot"
            :text="item.lines[0].text"
            class="mb-4 mr-md-4 mb-md-0"
          />
          <BaseIconWithText
            icon="fa-light fa-user"
            :text="item.lines[1].text"
            class="mr-md-4 mb-4 mb-md-0"
          />
          <BaseIconWithText
            icon="fa-light fa-calendar"
            :text="item.lines[2].text"
            class="mr-md-4 mb-md-0"
          />
        </BaseCardWithIcon>
      </div>
    </template>
    <template #right-content>
      <TheSubscriptionFilter
        title="Filtres"
        :filters-items="subscriptionTypes"
        filters-submit-button-text="Valider"
        header-action-button-text="Supprimer tous les filtres"
        class="mt-20"
      />
    </template>
  </Layout>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { capitalize } from 'lodash';

import Layout from '@/views/containers/Layout.vue';
import BaseDialog from '@/components/BaseDialog.vue';
import BaseHeader from '@/components/BaseHeader.vue';
import BaseCardWithIcon from '@/components/BaseCardWithIcon.vue';
import BaseIconWithText from '@/components/BaseIconWithText.vue';
import TheSubscriptionFilter from '@/views/containers/TheSubscriptionFilter.vue';

export default {
  name: 'Subscriptions',

  components: {
    Layout,
    BaseDialog,
    BaseCardWithIcon,
    BaseHeader,
    BaseIconWithText,
    TheSubscriptionFilter,
  },

  data() {
    return {
      openFilterDialog: false,
      recycleScrollerKey: 0,
      subscriptionType: 0,
      subscriptionTypes: [
        {
          id: 0,
          attributes: {
            name: this.$t('Confirmed subscriptions'),
          },
        },
        {
          id: 1,
          attributes: {
            name: this.$t('Pending subscriptions short'),
          },
        },
        {
          id: 2,
          attributes: {
            name: this.$t('Rejected subscriptions'),
          },
        },
      ],
    };
  },

  computed: {
    ...mapGetters(['subscriptionList']),
    ...mapState(['subscriptionsFilter']),
    confirmedSubscriptions() {
      return this.subscriptionList.filter((subscription) => subscription.attributes.confirmed);
    },
    pendingSubscriptions() {
      return this.subscriptionList.filter((subscription) => !subscription.attributes.confirmed && !subscription.attributes.rejected_at);
    },
    rejectedSubscriptions() {
      return this.subscriptionList.filter((subscription) => subscription.attributes.rejected_at);
    },

    filteredSubscriptions() {
      if (this.subscriptionsFilter === 2) {
        return this.formatSubscriptions(this.rejectedSubscriptions);
      } if (this.subscriptionsFilter === 1) {
        return this.formatSubscriptions(this.pendingSubscriptions);
      }
      return this.formatSubscriptions(this.confirmedSubscriptions);
    },

    pageTitle() {
      if (this.subscriptionsFilter === 2) {
        return 'Mes inscriptions rejetées';
      } if (this.subscriptionsFilter === 1) {
        return 'Mes inscriptions en attente';
      }
      return 'Mes inscriptions confirmées';
    },

  },

  methods: {
    ...mapActions(['fetchSubscriptions']),

    goToSubscription(subscription) {
      this.$router.push(`/subscriptions/${subscription.id}`);
    },

    formatSubscriptions(subscriptions) {
      return subscriptions.map((subscription) => {
        const item = {
          id: subscription.id,
          title: subscription.sport.attributes.name,
          lines: [
            {
              icon: 'mdi-map-marker',
              text: subscription.campuses.map((campus) => campus.attributes.name).join(', '),
            },
            {
              icon: 'mdi-account',
              text: subscription.teacher.attributes.name,
            },
            {
              icon: 'mdi-account-check',
              text: this.$tc('presences', subscription.attributes.number_of_attendances),
            },
          ],
          icon: subscription.sport.attributes.icon || 'mdi-podium',
          confirmed: subscription.attributes.confirmed,
          rejected_at: subscription.attributes.rejected_at,
        };
        if (subscription.course.attributes.day_and_time) {
          item.lines.splice(2, 0, {
            icon: 'mdi-calendar',
            text: capitalize(subscription.course.attributes.day_and_time),
          });
        }
        return item;
      });
    },

    chipClass(confirmed, rejectedAt) {
      if (rejectedAt) {
        return 'red tone-100 red--text';
      } if (confirmed) {
        return 'green tone-100 green--text text--tone-400';
      }
      return 'brand-secondary tone-100 brand-secondary--text';
    },

    chipText(confirmed, rejectedAt) {
      if (rejectedAt) {
        return 'Inscription rejetée';
      } if (confirmed) {
        return 'Inscription confirmée';
      }
      return 'Inscription en attente';
    },

  },

  created() {
    this.fetchSubscriptions();
  },
};
</script>
